<template>
  <!-- 配置全局样式 -->
  <van-config-provider :theme-vars="themeVars">
    <router-view />
  </van-config-provider>
</template>

<script>
// : Modify - 移除未使用的inject导入 
import { onMounted } from "vue";
import { Toast } from "vant";
import { useStore } from "vuex";
// 引入home.js 获取宏观微观数据
import { getMicroAndMacroData } from "@/api/home";

export default {
  setup() {
    const themeVars = {
      // primary button 背景色
      buttonPrimaryBackgroundColor: "rgba(151,102,11,0.7)",
      // primary button 边框色
      buttonPrimaryBorderColor: "rgba(151,102,11,0.7)",
      // 索引栏侧边字体大小
      indexBarIndexFontSize: "2rem",
      // 索引栏侧边行高
      indexBarIndexLineHeight: "3rem",
      // 索引栏锚点字体大小
      indexAnchorFontSize: "2rem"
    }

    // : Delete - 移除未使用的axios注入 
    // const axios = inject("axios");

    const store = useStore();

    onMounted(async () => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      try {
        // : Add - 生成模拟数据替代API调用 
        // 模拟微观特征数据
        // const mockMicroData = [
        //   { id: 1, parentId: "-1", content: "导管", leaf: false, woodAppraisalId: null, type: "微观" },
        //   { id: 2, parentId: "-1", content: "轴向薄壁组织", leaf: false, woodAppraisalId: null, type: "微观" },
        //   { id: 3, parentId: "1", content: "散孔材", leaf: false, woodAppraisalId: null, type: "微观" },
        //   { id: 4, parentId: "1", content: "环孔材", leaf: false, woodAppraisalId: null, type: "微观" },
        //   { id: 5, parentId: "3", content: "单管孔", leaf: true, woodAppraisalId: 101, type: "微观" },
        //   { id: 6, parentId: "3", content: "复管孔", leaf: true, woodAppraisalId: 102, type: "微观" },
        //   { id: 7, parentId: "2", content: "环管状", leaf: true, woodAppraisalId: 103, type: "微观" },
        //   { id: 8, parentId: "2", content: "茄子", leaf: true, woodAppraisalId: 104, type: "微观" },
        //   { id: 9, parentId: "5", content: "黄花", leaf: true, woodAppraisalId: 105, type: "微观" },
        //   { id: 10, parentId: "5", content: "番茄", leaf: true, woodAppraisalId: 106, type: "微观" }
        // ];

        // // 模拟宏观特征数据
        // const mockMacroData = [
        //   { id: 101, parentId: "-1", content: "木材颜色", leaf: false, woodAppraisalId: null, type: "宏观" },
        //   { id: 102, parentId: "-1", content: "纹理", leaf: false, woodAppraisalId: null, type: "宏观" },
        //   { id: 103, parentId: "101", content: "红褐色", leaf: true, woodAppraisalId: 201, type: "宏观" },
        //   { id: 104, parentId: "101", content: "黄褐色", leaf: true, woodAppraisalId: 202, type: "宏观" },
        //   { id: 105, parentId: "102", content: "直纹", leaf: true, woodAppraisalId: 203, type: "宏观" },
        //   { id: 106, parentId: "102", content: "交错纹理", leaf: true, woodAppraisalId: 204, type: "宏观" }
        // ];
        // await store.dispatch("wood/setMicroList", mockMicroData);
        // await store.dispatch("wood/setMacroList", mockMacroData);



        const mockMicroData = await getMicroAndMacroData('微观');
        const mockMacroData = await getMicroAndMacroData('宏观');

        // 使用模拟数据
        await store.dispatch("wood/setMicroList", mockMicroData.data);
        await store.dispatch("wood/setMacroList", mockMacroData.data);
        //  利用本地存储缓存本地数据
        sessionStorage.setItem('microList', JSON.stringify(mockMicroData.data));
        sessionStorage.setItem('macroList', JSON.stringify(mockMacroData.data));

        Toast.clear();
      } catch (e) {
        Toast.fail('加载失败：' + e.message);
      }
    });

    return {
      themeVars
    }
  }
}
</script>

<style lang="less">
@import "/src/assets/css/index.less";

// 页面切换动画
.fade-leave-active,
.fade-enter-active {
  transition: all .3s ease-out;
}

.fade-leave-to,
.fade-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
</style>
